import {
  verificationTokenAtom,
  updateSurveyAtom,
  patientVerificationDataAtom,
  staffVerificationDataAtom,
} from '../../store';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useDeactivateSession = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [, setVerificationToken] = useAtom(verificationTokenAtom);
  const [, setInteraction] = useAtom(updateSurveyAtom);
  const [, setPatientData] = useAtom(patientVerificationDataAtom);
  const [, setStaffData] = useAtom(staffVerificationDataAtom);
  const careProviderSlug = location.pathname.split('/')[1];

  return useCallback((redirectPath?: string) => {
    setVerificationToken('');
    setInteraction(null);
    setPatientData({
      facility: '',
      firstName: '',
      lastName: '',
      patientId: '',
      careProviderId: 0,
      careProviderCoreId: '',
      careProviderName: '',
      careProviderSlug: '',
    });
    setStaffData({
      staffMemberId: '',
      firstName: '',
      lastName: '',
      careProviderId: 0,
      careProviderCoreId: '',
      careProviderName: '',
      careProviderSlug: '',
    });
    navigate(redirectPath ?? `/${careProviderSlug}`);
  }, [careProviderSlug, navigate, setVerificationToken, setInteraction, setPatientData, setStaffData]);
};
